import OurPractices from './OurPractices';

export default OurPractices;
